import { useEffect } from "react";
import { PolicyDetails } from "shared";

import { unstable__Button as Button } from "@hagerty/react-components";
import { PolicyVehicleV2 } from "@hagerty/customer-insurance-gateway-client";

import { getVehicleName } from "../../../utils/vehicleUtils";
import { Dialog } from "../../Dialog";
import style from "./RemoveVehicleDialog.module.scss";
import { useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/Tag.types";
import { mt } from "../../../utils/tracking";
import { useInsuranceContext } from "../InsuranceContext";

const confirmRemoveVehicleTagAction: TagAction = {
  actionName: "Yes, remove it",
  actionType: "button",
};

type RemoveVehicleDialogProps = {
  policy: PolicyDetails;
  vehicle: PolicyVehicleV2;
  onClose: () => void;
};

export const RemoveVehicleDialog = ({
  vehicle,
  policy,
  onClose,
}: RemoveVehicleDialogProps) => {
  const urls = useUrls();
  const vehicleName = getVehicleName(vehicle);
  const { hasTooManyVehiclesOnSinglePolicy } = useInsuranceContext();
  const { policyNumber, country } = policy;

  useEffect(() => mt.trackPopup("Remove"), []);

  const closeDialog = () => {
    mt.trackPopupClose();
    onClose();
  };

  return (
    <Dialog
      label="Confirm remove vehicle"
      role="dialog"
      onDismiss={closeDialog}
    >
      <div className={`${style.dialogHeading} modal__section-title`}>
        Are you sure you want to remove this vehicle from your policy?
      </div>
      <div className={style.actionWrapper}>
        <Button
          variant="solid"
          size="small"
          aria-label={`Remove ${vehicleName} from policy ${policyNumber}`}
          onClick={() => mt.trackAction(confirmRemoveVehicleTagAction)}
          href={urls.insurance.removeVehicle(
            policyNumber,
            `${vehicle.id ?? 0}`,
            country,
            hasTooManyVehiclesOnSinglePolicy
          )}
        >
          Yes, remove it
        </Button>
        <Button
          variant="outline"
          size="small"
          onClick={closeDialog}
          aria-label="Close remove vehicle dialog"
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};
